var img = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAQAAAC1+jfqAAAARElEQVR42mMYguD/mf9n8Eu7t3QBleCWZkhjUDkQB1WCqaClCyjpDoRnGNJwKAC5AWxCGg4zGFQY0iAkLnemQcjBFbYAj/En7WWefYgAAAAASUVORK5CYII=";
  export default img;